import { render } from "./ContractId.vue?vue&type=template&id=523e1d1e&scoped=true&ts=true"
import script from "./ContractId.vue?vue&type=script&lang=ts"
export * from "./ContractId.vue?vue&type=script&lang=ts"

import "./ContractId.vue?vue&type=style&index=0&id=523e1d1e&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523e1d1e"]])

export default __exports__